'use client';

import { type ReactNode } from 'react';
import { useRouter } from 'next/navigation';
import { Button as MokoButton, Card, Separator } from '@mokoboko/components';

import { PageContainer } from './page-container';
import { ChevronDown } from '@/icons';
import { useGoBack } from '@/hooks/use-go-back';
import { useIsMobile } from '@/hooks/use-is-mobile';

export const ReceiptPageShell = ({
  hasBackButton,
  children,
}: {
  hasBackButton?: boolean;
  children: ReactNode;
}) => {
  const router = useRouter();
  const { homePath } = useGoBack();
  const isMobile = useIsMobile();

  return (
    <PageContainer className="sm:!max-w-md">
      <Card contentClassName="p-5 sm:p-6 sm:space-y-6 space-y-5">
        {hasBackButton && (
          <>
            <MokoButton
              variant="secondary-gray"
              leadingIcon={<ChevronDown rotate={90} />}
              onClick={() => router.replace(homePath)}
              size={isMobile ? 'lg' : 'md'}
            >
              Go back
            </MokoButton>
            <Separator />
          </>
        )}

        {children}
      </Card>
    </PageContainer>
  );
};
